import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { DetailedUser } from '@webapp/platform/iam/entities/DetailedUser'
import { userQueryConfig } from '@webapp/platform/iam/query-configs/user'

type UseQueryUserDetailsReturn = {
  data: {
    user: DetailedUser
  }
  commands: {
    refetch: () => void
  }
  states: {
    isFetching: boolean
    isLoading: boolean
  }
}

export const useQueryUserDetails = ({
  userId,
}: {
  userId: number
}): UseQueryUserDetailsReturn => {
  const { data, isFetching, isLoading, refetch } = useQuery({
    ...userQueryConfig.getDetails(userId),
    staleTime: 5000,
  })

  const { user } = useMemo(() => {
    if (!data) return { user: undefined }
    return {
      user: new DetailedUser(data.data),
    }
  }, [data])

  return {
    data: {
      user,
    },
    commands: {
      refetch,
    },
    states: {
      isFetching,
      isLoading,
    },
  }
}
